import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css';
import Main from './main.jsx';
import zhCN from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd'
import reportWebVitals from './reportWebVitals';
import './i18n';

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
        <Main />
    </ConfigProvider>
    ,document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
